export function firstGrapheme(value: string | null | undefined): string {
  if (value == null) return '';
  const text = String(value).trim();
  if (!text) return '';
  if (typeof Intl !== 'undefined' && Intl.Segmenter) {
    const iterator = new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(text)[Symbol.iterator]();
    const first = iterator.next();
    return first.done ? '' : first.value.segment;
  }
  const match = text.match(/./u);
  return match ? match[0] : '';
}
